import { CtaSchema } from 'cms/schemaTypes/generalSchemas/cta'
import { SectionWithAssetListWithAssetPageSchema } from 'cms/schemaTypes/staticPages/documents/sectionWithAssetListWithAsset'
import Image from 'next/image'

import { urlFor } from 'lib/sanity/image'
import { getCMSCtaLinkParams } from 'lib/sanity/links'
import CustomPortableText from 'lib/sanity/richText/CustomPortableText'
import LinkButton from 'shared/ui/Button/LinkButton'
import FormattedText from 'shared/ui/FormattedText'

import {
  PageTitle,
  SectionContainer,
  SectionContent
} from '../landings/styles'

import styles from './HowToRegisterHeroSection.module.scss'

interface HowToRegisterHeroSectionProps {
  header: string
  content: SectionWithAssetListWithAssetPageSchema
  cta: CtaSchema
}

const HowToRegisterHeroSection = ({
  header,
  content,
  cta
}: HowToRegisterHeroSectionProps) => {
  return (
    <SectionContainer $condensed>
      <SectionContent $top={3} $topMobile={3} $bottom={20} $bottomMobile={20}>
        <PageTitle>
          <FormattedText text={header} />
        </PageTitle>
        <div className={styles.contentContainer}>
          <div className={styles.imageWrapper}>
            <Image
              src={urlFor(content.image.asset.asset).url()}
              alt={content.image.alt}
              width={800}
              height={800}
              quality={90}
              sizes={
                '(max-width: 764px) 100vw, (max-width: 1024px) 250px   , 500px'
              }
            />
          </div>
          <div className={styles.contentWrapper}>
            <div className={styles.stepsWrapper}>
              {content.sectionList.map(step => (
                <div key={step.key} className={styles.step}>
                  <Image
                    src={urlFor(
                      'image' in step ? step.image.asset.asset : ''
                    ).url()}
                    alt={'image' in step ? step.image.alt : ''}
                    width={36}
                    height={36}
                  />

                  <CustomPortableText value={step.content || []} />
                </div>
              ))}
            </div>
            <LinkButton
              className={styles.linkButton}
              href={getCMSCtaLinkParams(cta).href}
              variant='primary'
              size='large'
            >
              {cta.text}
            </LinkButton>
          </div>
        </div>
      </SectionContent>
    </SectionContainer>
  )
}

export default HowToRegisterHeroSection
